import React from 'react';
import './StatusBadge.css';

function StatusBadge({ status }) {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'betting_open':
        return { text: 'BETTING OPEN', className: 'status-betting' };
      case 'monitoring':
        return { text: 'OBSERVING', className: 'status-monitoring' };
      case 'awaiting_resolution':
        return { text: 'AWAITING RESOLUTION', className: 'status-monitoring' };
      case 'resolved':
        return { text: 'RESOLVED', className: 'status-resolved' };
      case 'voided':
        return { text: 'VOIDED', className: 'status-voided' };
      default:
        return { text: status.toUpperCase(), className: 'status-resolved' };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span className={`status-badge ${config.className}`}>
      {config.text}
    </span>
  );
}

export default StatusBadge;
